import React from 'react'
import { Link } from 'react-router-dom'
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { updateTapCount } from '../../../helpers/tapCountMutation';
function Review({ review, preview, theme, Textcolor, BtIColor, Iconcolor }) {
  const iconColor = BtIColor ? BtIColor : (Textcolor ? Textcolor : "black");

  const formatUrl = (url) => {
    if (!url) return url;
    return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
  };

  const reviewIcon = (
    <Avatar
      style={{ backgroundColor: "transparent", color: iconColor }}
      icon={<UserOutlined />}
    />
  );

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button, id) => {
    // console.log("iiii", id);

    updateTapCount(queryClient, button, id);
  };


  return (
    <div>
      <div className="grid grid-cols-2 gap-3 items-center p-2">
        {review.map((reviewDetails, index) => {
          return reviewDetails?.reviewName ? (
            <Link
              onClick={() => handleTap('reviews', reviewDetails._id)}
              to={`${preview ? formatUrl(reviewDetails?.reviewUrl) : ""}`}
              target={`${preview ? "_blank" : ""}`}
            >
              <div className="max-w-[197px] h-[139px]   rounded-[8px] items-center p-6" style={{ borderBottom: `1px solid ${Textcolor ? Textcolor : "black"}` }}>
                <div className="flex items-center justify-center h-[54px]">
                  <div
                    className="flex items-center p-2 justify-center rounded-[8px]"
                    style={{ backgroundColor: Iconcolor ? Iconcolor : "transparent" }}
                  >
                    {reviewIcon}
                  </div>
                </div>

                <p className="text-[12px] overflow-auto h-10 scrollbar-hide  font-medium text-center" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {reviewDetails.reviewName}
                </p>
              </div>
            </Link>
          ) : (
            ""
          );
        })}
      </div>
    </div>
  )
}

export default Review